import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { fetchBerThongPlayConfig, type BerThongSheet } from '../../services/berThongService'
import {
  formatCloseTime,
  formatCountdown,
  groupSheetsByHuay,
  isClosingSoon,
} from './berThongUi'
import './berThongGame.css'

const BerThongLobbyPage: React.FC = () => {
  const navigate = useNavigate()
  const showBerThongEntry = true
  const checked = true
  const [loading, setLoading] = useState(true)
  const [sheets, setSheets] = useState<BerThongSheet[]>([])
  const [nowMs, setNowMs] = useState(Date.now())

  useEffect(() => {
    const id = window.setInterval(() => setNowMs(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [])

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const res = await fetchBerThongPlayConfig()
      setSheets(res.data?.sheets || [])
    } catch (error) {
      await Swal.fire({
        icon: 'error',
        title: 'โหลดไม่สำเร็จ',
        text: error instanceof Error ? error.message : 'ไม่สามารถโหลดเบอร์ทอง',
      })
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!checked) return
    if (!showBerThongEntry) {
      setLoading(false)
      return
    }
    void load()
  }, [checked, showBerThongEntry, load])

  const groups = useMemo(() => groupSheetsByHuay(sheets, nowMs), [sheets, nowMs])
  const openGroups = useMemo(() => groups.filter((g) => g.openSheets.length > 0), [groups])

  if (!checked || loading) {
    return <div className="htd-bt__loading">กำลังโหลดเบอร์ทอง...</div>
  }

  if (!showBerThongEntry) {
    return (
      <div className="htd-bt">
        <div className="htd-bt__empty">
          <h2>เบอร์ทองยังไม่เปิด</h2>
          <p>รอแอดมินเปิดสิทธิ์การเล่น</p>
        </div>
      </div>
    )
  }

  return (
    <div className="htd-bt">
      <div className="htd-bt__hero">
        <div className="htd-bt__hero-copy">
          <p className="htd-bt__eyebrow">Points Game</p>
          <h2 className="htd-bt__title">เบอร์ทอง</h2>
          <p className="htd-bt__sub">เลือกหวย → เลือกแผ่น → กดเบอร์</p>
        </div>
        <Link to="/history/games/ber-thong" className="htd-bt__link">
          ประวัติ
        </Link>
      </div>

      {openGroups.length === 0 ? (
        <div className="htd-bt__empty">
          <h2>ยังไม่มีแผ่นเปิดขาย</h2>
          <p>รอแอดมินเปิดแผ่นเบอร์ทองงวดถัดไป</p>
          <button type="button" className="htd-bt__link" onClick={() => void load()}>
            รีเฟรช
          </button>
        </div>
      ) : (
        <div className="htd-bt__lobby-list">
          {openGroups.map((group) => {
            const count = formatCountdown(group.soonestCloseAt, nowMs)
            const soon = isClosingSoon(group.soonestCloseAt, nowMs)
            return (
              <button
                key={group.key}
                type="button"
                className={`htd-bt__lobby-card${soon ? ' is-urgent' : ''}`}
                onClick={() => navigate(`/points/games/ber-thong/huay/${encodeURIComponent(group.key)}`)}
              >
                <div className="htd-bt__lobby-main">
                  <strong>{group.huayName}</strong>
                  <span>
                    {group.openSheets.length} แผ่นเปิดขาย
                    {group.soonestCloseAt ? ` · ปิดรับเร็วสุด ${formatCloseTime(group.soonestCloseAt)}` : ''}
                  </span>
                </div>
                <div className="htd-bt__lobby-side">
                  {count ? <span className={soon ? 'is-urgent' : ''}>{count}</span> : null}
                  <span className="htd-bt__lobby-go">เลือก</span>
                </div>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default BerThongLobbyPage
